/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EnforcementCategoryEnum } from './enforcementCategoryEnum';
import { EnforcementStateEnum } from './enforcementStateEnum';


export interface EnforcementConfigPostSpec { 
    state?: EnforcementStateEnum;
    enforcement_category?: EnforcementCategoryEnum;
    service_type?: ServiceTypeEnum;
    exit_days?: number;
    /**
     * JSON object of overage threshold key-value
     */
    entrance_threshold?: object;
    /**
     * JSON object of signal metadata
     */
    signal_required?: object;
    /**
     * JSON object of email notification metadata
     */
    email_notification?: object;
    /**
     * JSON object of UI banner notification metadata
     */
    banner_notification?: object;
    /**
     * JSON object of UI toast notification metadata
     */
    toast_notification?: object;
}
export namespace EnforcementConfigPostSpec {
}


